import { GlobalIndicatorsDatasetKey } from "@/model/enum/globalIndicators/globalIndicatorsDatasetKey"
import { GlobalIndicatorsDataset } from "@/model/interfaces/globalIndicators/globalIndicatorsDataset"
import { Vue } from "vue-property-decorator"
import { GlobalIndicatorsAgePyramidFormatter } from "./globalIndicatorsAgePyramidFormatter"
import GlobalIndicatorsFilterService, { GlobalIndicatorsFilter } from "./GlobalIndicatorsFilterService"

export default class GlobalIndicatorsService {
  private static GLOBAL_INDICATORS_URI = "global_indicators"
  private static GLOBAL_INDICATORS_UPDATE_URI = GlobalIndicatorsService.GLOBAL_INDICATORS_URI + "/update"

  static async get(year: number | null, region: string | null, country: string | null, dutyStation: string | null): Promise<GlobalIndicatorsDataset> {
    const filter: GlobalIndicatorsFilter = {
      year,
      region,
      country,
      dutyStation
    }

    const url = GlobalIndicatorsFilterService.buildUrl("global_indicators", filter)

    return Vue.$axios.get(url).then(response => {
      const BENEFICIARIES_AGE_PYRAMID_BY_AOW = "beneficiariesAgePyramidByAOW"
      response.data[GlobalIndicatorsDatasetKey.BENEFICIARIES_AGE_PYRAMID_BY_AOW_AGRICULTURE] = GlobalIndicatorsAgePyramidFormatter.format(
        response.data[BENEFICIARIES_AGE_PYRAMID_BY_AOW]
      ).O1
      response.data[GlobalIndicatorsDatasetKey.BENEFICIARIES_AGE_PYRAMID_BY_AOW_SELF] = GlobalIndicatorsAgePyramidFormatter.format(
        response.data[BENEFICIARIES_AGE_PYRAMID_BY_AOW]
      ).O2
      response.data[GlobalIndicatorsDatasetKey.BENEFICIARIES_AGE_PYRAMID_BY_AOW_WAGE] = GlobalIndicatorsAgePyramidFormatter.format(
        response.data[BENEFICIARIES_AGE_PYRAMID_BY_AOW]
      ).O3
      response.data[GlobalIndicatorsDatasetKey.REGIONS_NAMES] = Object.keys(response.data[GlobalIndicatorsDatasetKey.REGIONS_LIST])
      return response.data as GlobalIndicatorsDataset
    })
  }

  static async clearCache(filters: GlobalIndicatorsFilter): Promise<boolean> {
    const response = await Vue.$axios.get(this.GLOBAL_INDICATORS_UPDATE_URI, {
      params: GlobalIndicatorsFilterService.normalizeFilters(filters)
    })

    return response.status === 204
  }
}
